import { Pickup } from './pickup';

export const ViewFilters = {
  [Pickup.id]: ({ homeCountry: country }) => !country || country === 'US',
};
